/**
 * @packageDocumentation
 * @module Core
 */

/**
 * Default context group.
 */
export const DefaultContextGroup = 'defaultContextGroup';
